import { render, staticRenderFns } from "./Vape.vue?vue&type=template&id=5a604dfa&scoped=true"
import script from "./Vape.vue?vue&type=script&lang=js"
export * from "./Vape.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a604dfa",
  null
  
)

export default component.exports